<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('标题')" prop="title">
                <a-input v-model="queryParam.title" :placeholder="$t('请输入标题')" allow-clear />
              </a-form-item>
            </a-col>
            <template v-if="advanced"> </template>
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
                <!--            <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('收起') : $t('展开') }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['problem:type:add']">
          <a-icon type="plus" />{{ $t('新增') }}
        </a-button>
        <a-button
          type="primary"
          :disabled="single"
          @click="$refs.createForm.handleUpdate(undefined, ids)"
          v-hasPermi="['problem:type:edit']"
        >
          <a-icon type="edit" />{{ $t('修改') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['problem:type:remove']">
          <a-icon type="delete" />{{ $t('删除') }}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['problem:type:export']">
          <a-icon type="download" />{{ $t('导出') }}
        </a-button>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="status" slot-scope="text, record">
          <a-popconfirm :ok-text="$t('是')" :cancel-text="$t('否')" @confirm="handleStatusType(record)">
            <span slot="title"
              >{{ $t('确认') }}<b>{{ record.status === 0 ? $t('启用') : $t('停用') }}</b> {{ record.title
              }}{{ $t('的类型吗?') }}
            </span>
            <a-switch :checked-children="$t('开')" :un-checked-children="$t('关')" :checked="record.status === 1" />
          </a-popconfirm>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['problem:type:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['problem:type:edit']">
            <a-icon type="edit" />{{ $t('修改') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['problem:type:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['problem:type:remove']">
            <a-icon type="delete" />{{ $t('删除') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `${$t('共')} ${total} ${$t('条')}`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageType, listType, delType, changeTypeStatus, editTypeStatus } from '@/api/problem/type'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Type',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        problemClassUrl: null,
        title: null,
        status: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('标识'),
          dataIndex: 'id',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('标题'),
          dataIndex: 'title',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('备注'),
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('显示排序'),
          dataIndex: 'orderSort',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('状态'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center'
        },
        {
          title: this.$t('插入时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {},
  watch: {},
  methods: {
    /** 查询常见问题分类列表 */
    getList() {
      this.loading = true
      pageType(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        problemClassUrl: undefined,
        title: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    // 状态修改
    handleStatusType(row) {
      row.status = row.status == '0' ? '1' : '0'
      editTypeStatus(row.id, row.status)
        .then(() => {
          this.$message.success('操作成功！')
          this.getList()
        })
        .catch(function () {
          row.status = row.status == '0' ? '1' : '0'
        })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('提示'),
        content: this.$t('确认删除所选中数据?'),
        onOk() {
          const data = []
          that.ids.map((id) => data.push({ id: id }))
          return delType(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'problem/type/export',
            {
              ...that.queryParam
            },
            `常见问题分类_${new Date().getTime()}.xls`
          )
        },
        onCancel() {}
      })
    }
  }
}
</script>
